import { memo } from 'react';
import { IFollowListSwitchTab } from '../../../../interfaces/components/profileElement.interface';
import { FollowPageEnum } from '../../../../interfaces/profile.interface';

const FollowListSwitchTab: React.FC<IFollowListSwitchTab> = ({
  followers,
  following,
  handleToggleFollowModal,
}) => {
  return (
    <>
      <div className="flex justify-center mt-6 mb-8">
        <span
          onClick={() => {
            handleToggleFollowModal(true, FollowPageEnum.Follower);
          }}
          className="border-r border-grey_1 text-center w-48 cursor-pointer"
        >
          <p className="text-blue-gradient text-[18px]">
            {followers?.filter((eachUser: any) => eachUser.isAccepted).length ||
              0}
          </p>
          <p className="text-primary_black text-[14px]">Theo dõi</p>
        </span>
        <span
          onClick={() => {
            handleToggleFollowModal(true, FollowPageEnum.Following);
          }}
          className="border-l border-grey_1 text-center w-48 cursor-pointer"
        >
          <p className="text-blue-gradient text-[18px]">
            {' '}
            {following?.filter((eachUser: any) => eachUser.isAccepted).length ||
              0}
          </p>
          <p className="text-primary_black text-[14px]">Đang theo dõi</p>
        </span>
      </div>
    </>
  );
};

export default memo(FollowListSwitchTab);
